import React from 'react';
import type { LibItemSysImage } from '@types';
import ItemList from '@components/ItemList';
import LibModalListHeader from '../layouts/LibModalListHeader';
import LibModalListBody from '../layouts/LibModalListBody';
import LibModalList from '../layouts/LibModalList';
import RowSysImage from './RowSysImage';

type Props = {
  data: LibItemSysImage[];
};

function ListSysImage({ data }: Props) {
  return (
    <LibModalList>
      <LibModalListHeader>根目录</LibModalListHeader>
      <LibModalListBody>
        <ItemList
          itemCount={data.length}
          itemData={{ items: data }}
          row={RowSysImage}
        />
      </LibModalListBody>
    </LibModalList>
  );
}

export default ListSysImage;
